<template>
  <layout-content>
    <form-component />
  </layout-content>
</template>

<script>
  import FormComponent from '@pbx/components/sip-accounts/form';
  export default {
    components: {
      FormComponent
    }
  };
</script>
